export const PRODUCT = 'GASOLINE ENGINE DIAGNOSTIC PRO™'

export const PRODUCT_TAGLINE =
  'THE COMPLETE VISUAL FAULT-FINDING SYSTEM FOR GASOLINE ENGINE TECHNICIANS'

/** Anchor id of the $26.90 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL =
  'https://gasoline-engine-diagnostic-pro.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/45TSxHWAHrec1f8qQgmi39/Diseno_sin_titulo-10.webp'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1777770560132644'
